import { createSlice } from '@reduxjs/toolkit'
import { formatCompanyInfoData } from '../../../../../helpers/companyInfo'
import { register } from '../../../../../helpers/reducerRegistry'
import { PERFORMANCE_SCORE_COLOR, SCORE_TYPE } from '../constant'
import {
  getHeaderCompanyAnalysis,
  getScoreRangesCreditRisk,
  getScoreRangesPerformance,
} from './thunk'

const initialState = {
  isLoadingHeaderCompanyAnalysis: true,
  data: {},
  isRedirect404: false,
  scoreRanges: {
    [SCORE_TYPE.CREDIT_RISK]: [],
    [SCORE_TYPE.PERFORMANCE]: [],
  },
}

const slice = createSlice({
  name: 'companyAnalysis/header',
  initialState,
  reducers: {
    resetStoreHeaderCompanyAnalysis: () => initialState,
    changeDataCompanyInfo: (state, action) => {
      state.data = { ...state.data, ...action.payload }
    },
  },
  extraReducers: (builder) => {
    //getHeaderCompanyAnalysis
    builder.addCase(getHeaderCompanyAnalysis.pending, (state) => {
      state.isLoadingHeaderCompanyAnalysis = true
    })
    builder.addCase(
      getHeaderCompanyAnalysis.fulfilled,
      (state, { payload = {} }) => {
        state.isLoadingHeaderCompanyAnalysis = false
        state.data = formatCompanyInfoData(payload)
        state.isRedirect404 = false
      },
    )
    builder.addCase(getHeaderCompanyAnalysis.rejected, (state, action) => {
      state.isLoadingHeaderCompanyAnalysis = false
      state.isRedirect404 = action.payload.response.status
    })
    //getScoreRangesCreditRisk
    builder.addCase(
      getScoreRangesCreditRisk.fulfilled,
      (state, { payload = [] }) => {
        state.isLoading = false
        state.scoreRanges[SCORE_TYPE.CREDIT_RISK] = payload
          .map((item) => ({
            ...item,
            color: item.scoreRangeCode,
          }))
          .reverse()
      },
    )
    //getScoreRangesPerformance
    builder.addCase(
      getScoreRangesPerformance.fulfilled,
      (state, { payload = [] }) => {
        state.isLoading = false
        state.scoreRanges[SCORE_TYPE.PERFORMANCE] = [...payload]
          .reverse()
          .map((item, index) => ({
            ...item,
            color: PERFORMANCE_SCORE_COLOR[index],
          }))
      },
    )
  },
})

export const selectCompanyInfo = (state) => state[slice.name].data
export const selectIsLoadingHeaderCompanyAnalysis = (state) =>
  state[slice.name].isLoadingHeaderCompanyAnalysis
export const selectIsRedirect404 = (state) => state[slice.name].isRedirect404
export const selectScoreRanges = (scoreType, callback) => (state) => {
  const data = state[slice.name].scoreRanges[scoreType]
  return callback ? callback(data) : data
}

export const { resetStoreHeaderCompanyAnalysis, changeDataCompanyInfo } =
  slice.actions

register(slice.name, slice.reducer)
